import { eur } from "../../lib/api";

export const OrderSummary = ({ items, subtotal, shipping }) => (
  <aside data-testid="checkout-summary" className="rounded-[14px] border border-[#8CD05A]/20 bg-[#0E2A1C] p-5 lg:sticky lg:top-24">
    <p className="font-serif-d font-black text-2xl mb-4">Tu pedido</p>
    <ul className="space-y-3">
      {items.map((i) => (
        <li key={i.id} className="flex gap-3 items-center">
          <img src={i.image} alt="" className="w-12 h-14 object-cover border border-[#F2B441]/40" />
          <span className="flex-1 text-sm">{i.name} <span className="text-[#C9D6C2]">· {i.size} × {i.qty}</span></span>
          <span className="font-mono-d text-sm">{eur(i.price * i.qty)}</span>
        </li>
      ))}
    </ul>
    <div className="mt-4 pt-4 border-t border-[#F6EEDC]/10 space-y-2 text-sm text-[#C9D6C2]">
      <div className="flex justify-between"><span>Subtotal</span><span className="font-mono-d">{eur(subtotal)}</span></div>
      <div className="flex justify-between"><span>Envío</span><span className="font-mono-d">{shipping === 0 ? "Gratis" : eur(shipping)}</span></div>
      <div className="flex justify-between items-baseline text-[#F6EEDC] pt-2"><span>Total</span><span data-testid="checkout-total" className="font-serif-d text-3xl">{eur(subtotal + shipping)}</span></div>
    </div>
  </aside>
);
